export interface WaitingRoom {
  id: string;
  organizationId: string;
  name: string;
}

export interface ConversationPreview {
  id: string;
  subject: string;
  readOnly: boolean;
  messageCount: number;
  participantCount: number;
  lastMessageSent: Date;
  lastMessagePreview: string;
  unread: boolean;
  participants: ConversationParticipant[];
  patient: ConversationPatient;
}

export interface Conversation {
  id: string;
  subject: string;
  readOnly: boolean;
  messageCount: number;
  participantCount: number;
  starterSystemUserId: string;
  starterFirstName: string;
  starterLastName: string;
  starterDisplayName: string;
  lastMessageSent: string;
  lastMessagePreview: string;
  starterParticipantId: string;
  messages: Message[];
  organization: ConversationOrganization;
  patient: ConversationPatient;
  participants: ConversationParticipant[];
}

export interface ConversationParticipant {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  pendingCount: string;
  deliveredCount: string;
  systemUserId: string;
}

export interface Message {
  id: string;
  conversationId: string;
  senderParticipantId: string;
  senderFirstName: string;
  senderLastName: string;
  senderDisplayName: string;
  created: string;
  priority: string;
  segments: MessageSegment[];
  participantActivity: ParticipantActivity[];
}

export interface Attachment {
  id: string;
  url: string;
  fileName: string;
  sizeBytes: number;
  mimeType: string;
  uploadedBy: string;
  created: string;
  modified: string;
}

export interface MessageSegment {
  id: string;
  messageId: string;
  message: string;
  attachment: Attachment;
  order: number;
  type: number;
  text: string;
}

export enum MessageSegmentTypes {
  Text = 0,
  Attachment = 1
}

export interface ParticipantActivity {
  id: string;
  delivered: Date;
  read: string;
  participantId: string;
  created: Date;
}

export interface ConversationOrganization {
  id: string;
  name: string;
  secureMessageFooter?: string;
  enableSecureConversations: boolean;
  secureConversationActiveFooter?: string;
}

export interface ConversationPatient {
  id: string;
  givenName: string;
  familyName: string;
}

export interface MassNotificationResponse {
  id: string;
  status: string;
  recordCount: number;
  processedCount: number;
  skippedCount: number;
  created: string;
  messageBody: string;
}
